import React from 'react';
import { logoPath } from '../../core/branding/logo';
const Brand = ({ variant = 'sidebar' }) => <span className={`workspace-brand workspace-brand--${variant}`}>
  <img src={logoPath} alt="Logo da plataforma" width="156" height="69" />
  {/* <span className="workspace-brand-copy"><strong>Sender Tech</strong><small>THERMOKING</small></span> */}
</span>;
export default Brand;
